import { render, staticRenderFns } from "./PlaceholderTool.vue?vue&type=template&id=233ddb83&scoped=true"
import script from "./PlaceholderTool.vue?vue&type=script&lang=js"
export * from "./PlaceholderTool.vue?vue&type=script&lang=js"
import style0 from "./PlaceholderTool.vue?vue&type=style&index=0&id=233ddb83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233ddb83",
  null
  
)

export default component.exports